export default __webpack_public_path__ + "95d7984fb6de838d82902ac58faad2d9.png";